import { render } from "./BarComponent.vue?vue&type=template&id=7d56a14c&scoped=true"
import script from "./BarComponent.vue?vue&type=script&lang=js"
export * from "./BarComponent.vue?vue&type=script&lang=js"

import "./BarComponent.vue?vue&type=style&index=0&id=7d56a14c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d56a14c"]])

export default __exports__